<template>
    <div>
        <v-row
            no-gutters
            v-if="
                companyUser &&
                isAccountActive &&
                (company.id !== currentUser.company.id || !isBobbeeBusiness)
            "
        >
            <v-col cols="12" class="pb-1">
                <span class="title ml-2">{{ roleTitle }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-2" v-if="!companyUser">
            <v-overlay :absolute="true" v-if="loadingCompanyUser" :model-value="loadingCompanyUser">
                <v-progress-circular indeterminate size="64" />
            </v-overlay>
        </v-row>
        <v-row no-gutters class="mt-2" v-if="companyUser && isAccountActive">
            <v-col cols="6" v-if="!isLegalPerson && !isBobbeeBusiness" class="pl-2">
                <v-select-filled
                    outlined
                    :items="availableRoles"
                    v-model="companyUser.role"
                    label="Rôle"
                    :disabled="currentUserIsAccountingEmployee || !hasAccessToCompany"
                    hide-details
                    density="compact"
                    item-title="text"
                />
            </v-col>
            <v-col cols="6" v-if="!isLegalPerson && company.id !== user.company.id" class="pl-2">
                <v-select-filled
                    outlined
                    :items="availableProfiles"
                    v-model="companyUser.profile.id"
                    :item-title="getProfileName"
                    item-value="id"
                    label="Profil"
                    hide-details
                    density="compact"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-2" v-if="companyUser && isAccountActive">
            <v-col cols="2" v-if="!isLegalPerson && accessRightPartition" class="pl-2">
                Droits d'accès
            </v-col>
            <v-col cols="10" v-if="!isLegalPerson && accessRightPartition" class="pl-2">
                <FreeTag
                    :company="company"
                    :companyTags="accessRightTags"
                    :onlyOneByPartition="false"
                    :partitionTagId="accessRightPartition.id"
                    :createIfMissing="true"
                    :companyUser="companyUser"
                    @onTagsChanged="onTagsChanged"
                />
            </v-col>
        </v-row>
        <v-divider class="my-2" v-if="companyUser && isAccountActive" />
        <v-row no-gutters v-if="companyUser">
            <v-col cols="12" class="pb-1">
                <span class="title ml-2">{{ legalRepresentativeTitle }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-2" v-if="companyUser && isAccountActive">
            <v-col cols="4" v-if="!isLegalPerson" class="pl-2">
                <v-switch
                    v-model="companyUser.partOfCompany"
                    hide-details
                    class="my-0"
                    label="Fait partie de la société"
                    :ripple="false"
                    v-if="user.company.id !== company.id"
                />
                <v-switch
                    v-model="partOfCompanyTrue"
                    hide-details
                    class="my-0"
                    label="Fait partie de la société"
                    :ripple="false"
                    readonly
                    v-else
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-2" v-if="companyUser">
            <v-col cols="4" v-if="!isLegalPerson" class="pl-2">
                <v-select-filled
                    outlined
                    :items="legalRepresentativeTypes"
                    v-model="companyUser.legalRepresentativeType"
                    label="Qualité"
                    :disabled="currentUserIsAccountingEmployee"
                    hide-details
                    @update:model-value="onLegalRepresentativeTypeChanged()"
                    density="compact"
                    item-title="text"
                />
            </v-col>
            <v-col cols="4" class="d-flex align-center pl-5">
                <v-switch
                    v-model="companyUser.accountingLegalRepresentative"
                    hide-details
                    class="my-0"
                    :label="switchLabel"
                    :ripple="false"
                    :disabled="companyUser.legalRepresentativeType == null"
                    :readonly="companyUser.legalRepresentativeType == null"
                />
            </v-col>
        </v-row>
        <v-divider class="my-2" v-if="companyUser && isAccountActive" />
        <!-- <v-row no-gutters class="py-2">
            <v-col cols="6">
                <v-select
                    v-model="referenceProfileId"
                    :items="availableProfiles"
                    :item-title="getProfileName"
                    item-value="id"
                    label="Profil de référence"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[(p) => !!p.length || 'Sélectionnez un profil']"
                    v-if="referenceProfileId"
                ></v-select>
            </v-col>
        </v-row> -->
        <!-- Gestion des encours<v-divider></v-divider>
        <v-row>
            <v-col>
                <v-checkbox
                v-model="companyUser.configuration.outstanding.supplier"
                label="Fournisseurs"
                color="primary"
                hide-details
                ></v-checkbox>
            </v-col>
            <v-col>
                <v-checkbox
                v-model="companyUser.configuration.outstanding.expenseReport"
                label="Note de frais"
                color="primary"
                hide-details
                ></v-checkbox>
            </v-col>
            <v-col>
                <v-checkbox
                v-model="companyUser.configuration.outstanding.salary"
                label="Salaire"
                color="primary"
                hide-details
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-checkbox
                v-model="companyUser.configuration.outstanding.client"
                label="Tous les clients"
                color="primary"
                hide-details
                @change="onOutstandingCustomerChanged"
                ></v-checkbox>
            </v-col>
            <v-col>
                <v-checkbox
                v-model="companyUser.configuration.outstanding.selectionClient"
                :label="'Selection de clients pour '+company.name"
                color="primary"
                hide-details
                @change="onOutstandingSelectionCustomerChanged"
                ></v-checkbox>
            </v-col>
             <v-col>
            </v-col>
        </v-row>
        <v-row v-if="companyUser.configuration.outstanding.selectionClient">
            <v-col>
                <v-text-field
                v-model="clientSearch"
                placeholder="Rechercher"
                :label="searchLabel"
                append-inner-icon="$clear"
                @click:append-inner="clientSearch = ''"
                outlined
                dense
                class="oss-"
                ></v-text-field>
            </v-col>
            <v-col>
                <v-btn
                    color="yellow"
                    elevation="0"
                    class="mr-2"
                    rounded
                     size="small"
                    @click="selectAllClients()"
                >
                    Tous les clients
                </v-btn>
            </v-col>
            <v-col>
                <v-btn
                    color="yellow"
                    elevation="0"
                    rounded
                     size="small"
                    @click="diselectAllClients()"
                >
                    Aucun client
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="companyUser.configuration.outstanding.selectionClient && !clientCompanies.length && !clientLoading">
            <v-col>
            Aucune client trouvé
            </v-col>
        </v-row>
        <v-row v-if="companyUser.configuration.outstanding.selectionClient && clientCompanies.length">
            <template v-if="!clientCompanies.length">
                Aucune client trouvé
            </template>
            <v-col cols="6" v-for="comp in clientCompanies" :key="comp.id" class="pr-2 pb-2">
                <v-list-item
                    ripple
                    class="oss-list-item"
                    @click="onCustomerClicked(comp)"
                >

                        <v-icon
                            left
                            :color="isSelectedCustomer(comp) ? 'primary' : 'secondary'"
                        >
                            {{ isSelectedCustomer(comp) ? "check_box" : "check_box_outline_blank" }}
                        </v-icon>

                        <v-list-item-title>
                            <span>{{ comp.name }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ comp.siret }}
                        </v-list-item-subtitle>
                </v-list-item>
            </v-col>
        </v-row> -->
        <!-- <v-col>
            <v-checkbox
                v-model="companyUser.configuration.outstanding.client"
                label="Tous les clients"
                color="primary"
                hide-details
            ></v-checkbox>
        </v-col>
        <v-col>
            <v-checkbox
            v-model="companyUser.configuration.outstanding.selectionClient"
            :label="'Selection de clients pour '+company.name"
            color="primary"
            hide-details
            ></v-checkbox>
        </v-col> -->

        <!-- Old version -->
        <!-- <v-window v-model="profileEditionStep">
        <v-window-item :value="'main'" transition="slide-x-transition">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-list subheader two-line>
                            <v-list-item
                                class="oss-list-item mb-2"
                                @click.stop="profileEditionStep = 'openpoints'"
                            >
                                <template v-slot:append style="width: 48px" class="my-0 d-flex justify-center">
                                    <v-icon color="primary">$oss-analysis</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Gestion des en cours
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ subTitleOpenpoints }}</v-list-item-subtitle>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-btn icon>
                                        <v-icon  size="small" color="primary">$oss-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                                @click.stop="profileEditionStep = 'payments'"
                            >
                                <template v-slot:append style="width: 48px" class="my-0 d-flex justify-center">
                                    <v-icon color="primary">$oss-bank</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Gestion des paiements
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ subTitlePayments }}</v-list-item-subtitle>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-btn icon>
                                        <v-icon  size="small" color="primary">$oss-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                                @click.stop="profileEditionStep = 'validation'"
                            >
                                <template v-slot:append style="width: 48px" class="my-0 d-flex justify-center">
                                    <v-icon color="primary">$fa-file-contract</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Gestion de la validation
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ subTitleValidation }}</v-list-item-subtitle>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-btn icon>
                                        <v-icon  size="small" color="primary">$oss-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :value="'openpoints'" transition="slide-x-transition">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-btn rounded="circle" size="small" class="back_btn" @click.stop="profileEditionStep = 'main'">
                            <v-icon>$navigate_before</v-icon>
                        </v-btn>
                        <span class="title ml-2">Gestion des en cours</span>
                        <v-list subheader two-line class="mt-2">
                            <v-list-item
                                class="oss-list-item mb-2"
                                @click.stop="profileEditionStep = 'openpoints-clients'"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-building</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Clients
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ subTitleOpenpointsCustomer }}</v-list-item-subtitle>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-btn icon>
                                        <v-icon  size="small" color="primary">$oss-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-building</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Fournisseurs
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.outstanding.supplier"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$oss-expense-report</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Note de frais
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.outstanding.expenseReport"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-hand-holding-usd</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Salaire
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.outstanding.salary"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :value="'openpoints-clients'" transition="slide-x-transition">
                <v-row no-gutters class="py-2">
                    <v-col cols="6">
                        <v-btn rounded="circle" size="small" class="back_btn" @click.stop="profileEditionStep = 'openpoints'">
                            <v-icon>$navigate_before</v-icon>
                        </v-btn>
                        <span class="title ml-2">
                            Clients
                        </span>
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                        <v-switch
                            v-model="companyUser.configuration.outstanding.client"
                            color="primary"
                            hide-details
                            class="my-0"
                            label="Activer pour tous les clients"
                            dense
                            :ripple="false"
                            inset
                            @change="onOutstandingCustomerChanged()"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row no-gutters class="py-2" v-if="!companyUser.configuration.outstanding.client">
                    <v-col cols="4">
                        <v-text-field
                            v-model="clientSearch"
                            label="Rechercher"
                            append-inner-icon="$clear"
                            @click:append-inner="clientSearch = ''"
                            outlined
                            hide-details
                            dense
                            class="oss-"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-2 d-flex align-center">
                        <template v-if="companyUser.clients.length > 0">
                            <v-btn
                                color="yellow"
                                elevation="0"
                                rounded
                                 size="small"
                                @click="diselectAllClients()"
                            >
                                Aucun client
                            </v-btn>
                        </template>
                        <template v-else>
                            <v-btn
                                color="yellow"
                                elevation="0"
                                class="mr-2"
                                rounded
                                 size="small"
                                @click="selectAllClients()"
                            >
                                Sélectionner tous les clients
                            </v-btn>
                        </template>
                    </v-col>
                </v-row>
                <v-row class="mb-3">
                    <template v-if="!clientCompanies.length">
                        <v-col cols="12">
                            Aucune client trouvé
                        </v-col>
                    </template>
                    <template v-else-if="companyUser.configuration.outstanding.client">
                        <v-col cols="12">
                            Tous les clients sont sélectionnés
                        </v-col>
                    </template>
                    <v-col cols="6" v-for="comp in clientCompanies" :key="comp.id" class="pr-2 pb-2" v-else>
                        <v-list-item
                            ripple
                            class="oss-list-item"
                            @click="onCustomerClicked(comp)"
                        >
                                <v-icon
                                    left
                                    :color="isSelectedCustomer(comp) ? 'primary' : 'secondary'"
                                >
                                    {{ isSelectedCustomer(comp) ? "check_box" : "check_box_outline_blank" }}
                                </v-icon>

                                <v-list-item-title>
                                    <span>{{ comp.name }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ getSiretValue(comp.siret) }}
                                </v-list-item-subtitle>
                            </template>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :value="'payments'" transition="slide-x-transition">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-btn rounded="circle" size="small" class="back_btn" @click.stop="profileEditionStep = 'main'">
                            <v-icon>$navigate_before</v-icon>
                        </v-btn>
                        <span class="title ml-2">Gestion des paiements</span>
                        <v-list subheader two-line class="mt-2">
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-building</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Fournisseurs
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.payments.supplier"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$oss-expense-report</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Note de frais
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.payments.expenseReport"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-hand-holding-usd</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Salaire
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.payments.salary"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :value="'validation'" transition="slide-x-transition">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-btn rounded="circle" size="small" class="back_btn" @click.stop="profileEditionStep = 'main'">
                            <v-icon>$navigate_before</v-icon>
                        </v-btn>
                        <span class="title ml-2">Gestion de la validation</span>
                        <v-list subheader two-line class="mt-2">
                            <v-list-item
                                class="oss-list-item mb-2"
                            >
                                <template v-slot:append style="width: 48px" class="my-0">
                                    <v-icon color="primary">$fa-building</v-icon>
                                </template>
                                <template class="py-0">
                                    <v-list-item-title>
                                        Fournisseurs
                                    </v-list-item-title>
                                </template>
                                <template v-slot:append class="my-0">
                                    <v-switch
                                        v-model="companyUser.configuration.validation.supplier"
                                        color="primary"
                                        hide-details
                                        class="my-0"
                                        dense
                                        :ripple="false"
                                        inset
                                    ></v-switch>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window> -->
        <!-- New Version -->
        <ProfileManagement
            v-if="isAccountActive"
            :companyId="company.id"
            :user="user"
            :companyUser="companyUser"
            :inComponent="true"
            @updatedCompanyUser="updateCompanyUser($event)"
        />
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import { User } from "../../store/store";

import { Offer_type } from "@/types/offer.types";

import COMPANY_USER from "../../graphql/user/CompanyUser.gql";
import UPSERT_COMPANY_USER from "../../graphql/user/UpsertCompanyUser.gql";
import REFERENCE_PROFILES from "../../graphql/profiles/ReferenceProfiles.gql";
import ACCESS_RIGHT_PARTITION_TAG from "../../graphql/tag/AccessRightPartitionTags.gql";
import { Apollo } from "@/decorators";

import { getProfileName } from "../../services/profile";

import FreeTag from "../tag/FreeTag.vue";
import { getCompanyTags } from "../../services/tagServices";
import ProfileManagement from "./ProfileManagement.vue";
import { defaultCompanyUser } from "@/services/user/companyUser";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        FreeTag,
        ProfileManagement,
    },
    emits: ["upserted"],
})
export class ProfileEdition extends Vue {
    @Prop({ default: null }) company;
    @Prop({ default: null }) user;
    @Prop({ default: null }) actions: any;
    @Prop({ default: false }) isAccountActivated: boolean;
    // @Prop({ default: false }) showUpdateButton

    partOfCompanyTrue: boolean = true;

    availableRoles = [
        { value: "UNKNOWN", text: "Pas de rôle" },
        { value: "OWNER", text: "Propriétaire" },
    ];

    legalRepresentativeTypes = [
        { text: "Sans qualité", value: null },
        { text: "Chef d'entreprise", value: "CEO" },
        { text: "Gérant", value: "MANAGING_DIRECTOR" },
        { text: "Président", value: "PRESIDENT" },
        { text: "Directeur", value: "SUPERVISOR" },
        { text: "Directeur général", value: "GENERAL_SUPERVISOR" },
    ];

    upsertLoading: boolean = false;

    // profileEditionStep = "openpoints"
    profileEditionStep = "main";

    // clientSearch = ""

    get offerType() {
        return this.$store.state.offerType;
    }

    get isBobbeeBusiness() {
        switch (this.offerType) {
            case Offer_type.BUSINESS_BASIC:
            case Offer_type.BUSINESS_SMART:
            case Offer_type.BUSINESS_ESSENTIAL:
            case Offer_type.BUSINESS_PREMIUM:
                return true;
            default:
                return false;
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get hasAccessToCompany() {
        // Check if the user already has this company in his availableCompanies
        return !!this.user.availableCompanies.some((c) => c.id === this.company.id);
    }

    get currentUserIsAccountingEmployee() {
        return this.currentUser?.isAccountingEmployee;
    }

    get isLegalPerson() {
        return this.user.type === "LEGAL_PERSON";
    }

    /**
     * Checks if the user is coming from the "/me/users" menu.
     * @returns {boolean} `true` if the previous route ends with "/me/users", otherwise `false`.
     */
    get isFromUsersMenu(): boolean {
        const previousRoute = this.$router.options.history.state.back as string;
        return previousRoute && previousRoute.endsWith("/me/users");
    }

    get switchLabel() {
        if (this.isFromUsersMenu) {
            return "Représentant légal de la société";
        }
        return "Représentant légal du dossier";
    }

    // get referenceProfileId() {
    //     // if (this.user.profile.referenceProfile?.id) {
    //     //     return this.user.profile.referenceProfile.id
    //     // }
    //     if (this.availableProfiles.length) {
    //         return this.availableProfiles[0].id
    //     }
    //     return null
    // }

    // set referenceProfileId(value) {
    //     this.user.profile.referenceProfile = this.availableProfiles.find(ap => ap.id === value)
    // }

    get profileId() {
        if (this.user.profile) {
            return this.user.profile.id || undefined;
        }
        return undefined;
    }

    get roleTitle() {
        let title = "Rôle dans la société ";
        if (!this.isFromUsersMenu) {
            title = "Rôle dans le dossier ";
        }
        title += this.company?.name || "";
        return title;
    }

    get legalRepresentativeTitle() {
        let title = "Qualité dans la société ";
        if (!this.isFromUsersMenu) {
            title = "Qualité dans le dossier ";
        }
        title += this.company?.name || "";
        return title;
    }

    /**
     * Checks if the user is active.
     */
    get isAccountActive() {
        return this.isAccountActivated === true;
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            // this.actions.action.disabled = this.disabledSave
            this.actions.action.function = this.upsert;
            this.actions.action.loading = () => {
                return this.upsertLoading;
            };
        }
    }

    @Apollo({
        query: COMPANY_USER,
        variables() {
            return {
                companyId: this.company.id,
                userId: this.user.id,
            };
        },
        skip() {
            return !this.company?.id || this.user?.id === undefined;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.companyUserFirst) {
                    const companyUser = data.companyUserFirst;
                    console.log("Jalapeños");
                    console.log(companyUser);
                    if (!companyUser.profile) {
                        companyUser.profile = {
                            id: "",
                            name: "",
                        };
                    }
                    if (!companyUser.investment) {
                        companyUser.investment = {
                            capitalShare: 0,
                            amount: 0,
                        };
                    }
                    if (!companyUser.role) {
                        companyUser.role = "UNKNOWN";
                    }
                    if (!companyUser.legalRepresentativeType) {
                        companyUser.legalRepresentativeType = null;
                    }
                    if (!companyUser.accountingLegalRepresentative) {
                        companyUser.accountingLegalRepresentative = false;
                    }
                    if (!companyUser.accessRights) {
                        companyUser.accessRights = [];
                    }
                    if (!companyUser.clients) {
                        companyUser.clients = [];
                    }
                    if (!companyUser.configuration) {
                        companyUser.configuration = {};
                    }

                    if (!companyUser.configuration.outstanding) {
                        companyUser.configuration.outstanding = {
                            client: false,
                            selectionClient: false,
                            supplier: false,
                            expenseReport: false,
                            salary: false,
                        };
                    }
                    if (!companyUser.configuration.payments) {
                        companyUser.configuration.payments = {
                            salary: false,
                            expenseReport: false,
                            supplier: false,
                        };
                    }
                    if (!companyUser.configuration.validation) {
                        companyUser.configuration.validation = {
                            supplier: false,
                        };
                    }
                    this.companyUser = companyUser;
                } else {
                    this.companyUser = _.cloneDeep(defaultCompanyUser);
                }
            }
        },
    })
    companyUser: any = _.cloneDeep(defaultCompanyUser);

    get loadingCompanyUser() {
        if (this.$apollo.queries.companyUser) {
            return this.$apollo.queries.companyUser.loading;
        }
        return false;
    }

    @Apollo({
        query: REFERENCE_PROFILES,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.profiles) {
                    data.profiles.sort((a, b) => {
                        if (this.$t("profiles.name." + a.name) < this.$t("profiles.name." + b.name))
                            return -1;
                        if (this.$t("profiles.name." + a.name) > this.$t("profiles.name." + b.name))
                            return 1;
                        return 0;
                    });

                    data.profiles.splice(0, 0, {
                        id: "",
                        name: "Non défini",
                        displayName: "Non défini",
                    });
                    this.availableProfiles = data.profiles;
                    // if (this.availableProfiles.length) {
                    //     if (!this.user.profile) {
                    //         this.user.profile = this.availableProfiles[0];
                    //     }
                    // }
                }
            }
        },
    })
    availableProfiles: any = [];

    //
    // access right partitiion
    //

    @Apollo({
        query: ACCESS_RIGHT_PARTITION_TAG,
        variables() {
            return {
                companyId: this.company.id,
            };
        },
        skip() {
            return !this.company.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.partitionTags.length) {
                    this.accessRightPartition = data.partitionTags[0];
                    const accessRightTags = [];
                    getCompanyTags(
                        this,
                        this.company.id,
                        this.accessRightPartition.tags,
                        accessRightTags,
                    );
                    this.accessRightTags = accessRightTags;
                } else {
                    this.accessRightPartition = null;
                    this.accessRightTags = [];
                }
            }
        },
    })
    accessRightPartition: any = null;

    accessRightTags = [];

    //
    //
    //

    getProfileName(profile) {
        if (profile) {
            return getProfileName(this, profile);
        }
        debugger; // git-ignore
        return "XXXX";
    }

    onLegalRepresentativeTypeChanged() {
        if (this.companyUser.legalRepresentativeType === null) {
            this.companyUser.accountingLegalRepresentative = false;
        }
    }

    async refetchCompanyUser() {
        await this.$apollo.queries.companyUser.refetch();
    }

    async upsert() {
        debugger;
        this.upsertLoading = true;
        // Do not attempt to persist if the user does not have an ID
        if (!this.user.id) {
            console.info("L'utilisateur n'a pas encore d'ID, impossible de persister les données");
            this.upsertLoading = false;
            return;
        }
        const result = await this.$apollo.mutate({
            mutation: UPSERT_COMPANY_USER,
            variables: {
                id: this.companyUser.id,
                companyId: this.company.id,
                userId: this.user.id,
                createProfile:
                    this.companyUser.profile && this.companyUser.profile.id
                        ? { connect: { id: this.companyUser.profile.id } }
                        : undefined,
                updateProfile:
                    this.companyUser.profile && this.companyUser.profile.id
                        ? { connect: { id: this.companyUser.profile.id } }
                        : undefined,
                investment: this.companyUser.investment,
                role: this.companyUser.role !== "UNKNOWN" ? this.companyUser.role : null,
                legalRepresentativeType: this.companyUser.legalRepresentativeType,
                accountingLegalRepresentative: this.companyUser.accountingLegalRepresentative,
                configuration: this.companyUser.configuration,
                clients: this.companyUser?.clients?.map((c) => ({ id: c.id })) || [],
                accessRights: this.companyUser?.accessRights?.map((ar) => ({ id: ar.id })) || [],
                partOfCompany:
                    this.user.company.id !== this.company.id
                        ? this.companyUser.partOfCompany
                        : undefined,
            },
        });
        if (result?.data?.upsertCompanyUser?.id) {
            this.companyUser.id = result.data.upsertCompanyUser.id;
        } else {
            debugger; // git-ignore
        }
        this.upsertLoading = false;
        this.$emit("upserted");
    }

    onTagsChanged(data) {
        this.companyUser.accessRights = data.tags;
    }

    // getSiretValue(siret: string) {
    //     return getSiretValue(siret)
    // }

    updateCompanyUser(companyUser) {
        if (companyUser) {
            debugger;
            // Check if there is any differences between companyUser and this.companyUser
            if (JSON.stringify(companyUser) !== JSON.stringify(this.companyUser)) {
                this.companyUser = JSON.parse(JSON.stringify(companyUser));
            }
        }
    }
}

export default toNative(ProfileEdition);
</script>
